import React from 'react';
import { TextField, Box } from '@mui/material';

const TimeIntervalInput = ({ value = { hours: 0, minutes: 0 }, onChange }) => {
  // Ensure we have default values if value is null or undefined
  const hours = value?.hours || 0;
  const minutes = value?.minutes || 0;

  const handleHoursChange = (e) => {
    // Ensure we have a valid number
    const newHours = Math.max(0, parseInt(e.target.value) || 0);
    
    // Call parent onChange with updated values
    onChange({ 
      hours: newHours,
      minutes: minutes
    });
  };

  const handleMinutesChange = (e) => {
    // Ensure we have a valid number between 0-59
    const newMinutes = Math.min(59, Math.max(0, parseInt(e.target.value) || 0));
    
    // Call parent onChange with updated values
    onChange({ 
      hours: hours,
      minutes: newMinutes
    });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        type="number"
        label="Hours"
        value={hours}
        onChange={handleHoursChange}
        inputProps={{ min: 0, step: 1 }}
        size="small"
        sx={{
          width: '70px',
          '& input': { color: 'white' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.23)' },
            '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.5)' },
          },
          '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' }
        }}
      />
      <TextField
        type="number"
        label="Minutes"
        value={minutes}
        onChange={handleMinutesChange}
        inputProps={{ min: 0, max: 59, step: 1 }}
        size="small"
        sx={{
          width: '70px',
          '& input': { color: 'white' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.23)' },
            '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.5)' },
          },
          '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' }
        }}
      />
    </Box>
  );
};

export default TimeIntervalInput;
